import { render } from "./BaseDiagram.vue?vue&type=template&id=d9a9b85c&ts=true"
import script from "./BaseDiagram.vue?vue&type=script&lang=ts"
export * from "./BaseDiagram.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__